import { __ } from '../../../../../i18n';

export function lastExecutionCell() {
  return {
    SUCCESS: { name: __('Success'), fontColor: '#00A656' },
    FAILED: { name: __('Error'), fontColor: '#ED335F' },
  };
}
